import React from 'react';
import { Button, Form, Input, notification } from 'antd';
import Request from '../model/Request';
import { Item } from '../components/Views/Item';
import { ErrorForm, FormError } from './FormUtils';
import Flex from '../components/StyledComponents/Flex';
import './Forms.css';
import { isNullOrUndefined } from '../utils';
import { useTranslation } from '@nic-react-i18n/core';
import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@nic-react/auth';
import { AppConf } from '../AppConf';
import { useLocation } from 'react-router';
import { useAppendAuthorizationHeader } from '../utils/connector/api-connector';
import Contact from '../model/Contact';

// import Error, { ErrorLevel } from '../components/Error/Error';
export interface IpPostInterface {
    ipAddress: string;
}

export interface ModalDataI {
    ip?: string
    contact?: Contact
}

interface IpFormInterface {
    errorInfo: FormError;
    ipAddress?: string;
    readOnly: boolean;
    loading: boolean;
    handleCancel: (data?: ModalDataI) => void;
}

type IpFormProps = IpFormInterface

const ipAddressRegEx = /([0-9]{1,3}\.){3}[0-9]{1,3}$/;

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 18 },
};



const IpForm: React.FC<IpFormProps> = (props) => {
    const [ip, setIp] = React.useState('')
    const location = useLocation()
    const header = useAppendAuthorizationHeader()
    const [form] = Form.useForm()
    //const navigate = useNavigate()
    const {t} = useTranslation()
    const {keycloak} = useKeycloak()
    //const {tokenParsed} = keycloak

    const updateIp = async (data: IpPostInterface) => {
        const {url:rootAPI} = AppConf.getRootUrl(keycloak.realm)

        const response = await fetch(`${rootAPI}${location.pathname}/ipAddress  `, {
            method: 'PUT',
            body: JSON.stringify(data),
            ...header
        })

        if (!response.ok) {
            throw new Error('')
        }

        return response.json()
    }


    React.useEffect(() => {
        const {ipAddress,  readOnly} = props;
        if (!readOnly && ! isNullOrUndefined(ipAddress)) {
            form.setFieldsValue({ip: ipAddress})
            setIp(ipAddress??'')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const valuesChanged = (newValues: IpPostInterface): boolean => {
        return (
            isNullOrUndefined(ip) ||
            (!isNullOrUndefined(ip) && newValues.ipAddress !== ip));
    }

    const {mutateAsync, isError, error} = useMutation(updateIp)




    const renderForm = (errorInfo: FormError) => {

        const {loading, ipAddress} = props;
        const action = isNullOrUndefined(ipAddress) ? 'new' : 'modify';
        return (
            <div>
                <Form form={form}>
                    <Form.Item
                        name={'ip'}
                        {...formItemLayout}
                        label={t('ipForm.label.ip')}
                        rules={
                            [
                                {
                                    required: true,
                                    pattern: ipAddressRegEx,
                                    message: t('ipForm.message.ip')
                                }
                            ]
                        }
                    >

                        <Input
                            autoComplete={'ip'}
                            placeholder={t('ipForm.placeholder.ip')}
                        />
                    </Form.Item>
                </Form>
                <div

                >
                    {isError &&

                        <ErrorForm
                            formKind={'ipForm'}
                            errorMessage={(error as Error).message}
                        />

                    }
                </div>
                <Flex
                    direction={'row'}
                    justify={'space-between'}
                    align={'center'}
                    className={'separator'}
                >

                    <Button
                        size={'small'}
                        onClick={() => {props.handleCancel(); }}
                    >
                        {t(`ipForm.button.${action}.cancel`)}
                    </Button>

                    <Button
                        size={'small'}
                        loading={loading}
                        onClick={() => {
                            form.validateFields().then(() => {
                                let fields: IpPostInterface = {} as IpPostInterface;

                                fields.ipAddress = form.getFieldValue('ip');

                                let changedValues = valuesChanged(fields);
                                if (changedValues) {
                                    mutateAsync(fields)
                                        .then((result: Request) => {

                                            //console.log('PutIpResult: ', result.ipAddress)
                                            notification.success(
                                                {
                                                    message:
                                                        t('ipForm.success.modification.title'),
                                                    description:
                                                        t('ipForm.success.modification.description')
                                                }
                                            );
                                            form.setFieldsValue({ip: result.ipAddress})
                                            /*
                                                                                        queryClient.invalidateQueries({queryKey: ['requests', 'registrar',  `${tokenParsed.registrar}`]})
                                                                                            .then(()=> {

                                                                                                notification.success(
                                                                                                    {
                                                                                                        message:
                                                                                                            t('ipForm.success.modification.title'),
                                                                                                        description:
                                                                                                            t('ipForm.success.modification.description')
                                                                                                    }
                                                                                                );
                                                                                                console.log('IPFORM: navigate: ', location.pathname)
                                                                                                //navigate(0)
                                                                                        })
                                            */

                                        })
                                        .catch(() => {
                                            notification.error(
                                                {
                                                    message:
                                                        t('ipForm.warning.modification.title'),
                                                    description:
                                                        t('ipForm.warning.modification.description')
                                                }
                                            );
                                        })
                                        .finally(() => props.handleCancel({ip:fields.ipAddress}))
                                } else {
                                    notification.warning(
                                        {
                                            message:
                                                t('ipForm.warning.modification.title'),
                                            description:
                                                t('ipForm.warning.modification.description')
                                        }
                                    );
                                }

                            }).catch(() => {
                                notification.warning(
                                    {
                                        message:
                                            t('ipForm.error.modification.title'),
                                        description:
                                            t('ipForm.error.modification.description')
                                    }
                                );
                            })

                        }}
                    >
                        {t(`ipForm.button.${action}.ok`)}
                    </Button>
                </Flex>
            </div>
        )
    }

    const renderReadOnly = () => {
        const {ipAddress} = props;
        return (
            <div>
                <Item
                    label={t('ipForm.label.ip')}
                    value={ipAddress ?? ''}
                />

                <Flex
                    direction={'row'}
                    justify={'flex-end'}
                    align={'center'}
                    className={'separator distance'}
                >

                    <Button
                        size={'small'}
                        onClick={() => {props.handleCancel(); }}
                    >
                        {t(`contactForm.button.cancel`)}
                    </Button>
                </Flex>
            </div>
        );
    }


    const {readOnly, errorInfo} = props;
    let component = (readOnly ? renderReadOnly() : renderForm(errorInfo));
    return (
        <div>
            {component}
        </div>
    );
}

export default IpForm